// import {testWebpack} from '@/noSAAS/test'
export default {
  data () {
    // console.log(SPCompanyId)
    return {
      'SPCompanyId': process.env.VUE_APP_COMPANY_ID || 1,
      'Sp_storeData': [],
      'Sp_guideData': []
    }
  },
  computed: {},
  mounted () {
    // testWebpack()
  },
  methods: {
    runParentHandle () {
      console.log('runParentHandle', this.$parent)
      this.$parent.callHandle && this.$parent.callHandle()
    },
    //获取门店选择器返回数据
    Sp_getStoreData () {
      console.log('获取门店选择器返回数据-Sp_getStoreData', arguments)
      this.Sp_storeData = [...arguments]
    },
    //获取导购选择器返回数据
    Sp_getGuideData () {
      console.log('获取导购选择器返回数据-Sp_getGuideData', arguments)
      this.Sp_guideData = [...arguments]
      this.showBox = false
    }
  }
}
